// For Vite, we'll use CSS variables directly
// The fonts will be loaded via Google Fonts link in index.html

export const fontSans = {
  variable: "--cd-font-sans",
};

export const fontMono = {
  variable: "--cd-font-mono",
};

export const fontDoto = {
  variable: "--cd-font-doto",
};
